import { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { auth, database } from '../../firebase';
import { ref, onValue } from 'firebase/database';

export const useAuthAndUser = () => {
  const [userName, setUserName] = useState('');
  const [userEmail, setUserEmail] = useState('');
  const navigate = useNavigate();

  useEffect(() => {
    const user = auth.currentUser;
    if (user) {
      const userRef = ref(database, `users/${user.uid}`);
      onValue(userRef, (snapshot) => {
        const userData = snapshot.val();
        if (userData) {
          setUserName(userData.fullName || '');
          setUserEmail(userData.email || '');
        }
      });
    }
  }, []);

  const handleLogout = async () => {
    try {
      await auth.signOut();
      navigate('/');
      return true;
    } catch (error) {
      console.error('Error signing out:', error);
      return false;
    }
  };

  const handleUpgrade = () => {
    navigate('/subscribe');
  };

  return {
    userName,
    userEmail,
    handleLogout,
    handleUpgrade
  };
};
